export enum DateFormat {
	FORMAT_1 = 'dd/MM/yyyy HH:mm',
	FORMAT_2 = 'dd/MM/yyyy HH:mm:ss',
	FORMAT_3 = 'dd-MM-yyyy HH:mm',
	FORMAT_4 = 'dd-MM-yyyy HH:mm:ss',
	FORMAT_5 = 'yyyy/MM/dd HH:mm',
	FORMAT_6 = 'yyyy/MM/dd HH:mm:ss',
	FORMAT_7 = 'yyyy-MM-dd HH:mm',
	FORMAT_8 = 'yyyy-MM-ddTHH:mm:ss',
	FORMAT_9 = 'dd/MM/yyyy',
	FORMAT_10 = 'dd-MM-yyyy',
	FORMAT_11 = 'yyyy/MM/dd',
	FORMAT_12 = 'yyyy-MM-dd',
	FORMAT_ONLY_YEAR = 'yyyy',
}

export const MONTH_NAME_LIST: string[] = [
	'JANUARY',
	'FEBRUARY',
	'MARCH',
	'APRIL',
	'MAY',
	'JUNE',
	'JULY',
	'AUGUST',
	'SEPTEMBER',
	'OCTOBER',
	'NOVEMBER',
	'DECEMBER',
];
